module.exports = __webpack_public_path__ + "img/02叶会华.224a8ba3.png";